export default "__VITE_ASSET__CGw1ukzu__"